import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogService } from '@core/logging';
import { finalize, tap } from 'rxjs/operators';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor(private logService: LogService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler) {
    const started = Date.now();
    let success = false;
    let statusCode: number | undefined;

    // extend server response observable with logging
    return next.handle(req).pipe(
      tap({
        next: event => {
          success = event instanceof HttpResponse;
          if (event instanceof HttpResponse) {
            statusCode = event.status;
          }
        },
        error: error => {
          if (error instanceof HttpErrorResponse) {
            statusCode = error.status;
          }
        },
      }),
      finalize(() => {
        const elapsed = Date.now() - started;
        const msg = `${req.method} "${req.urlWithParams}" ${
          success ? 'succeeded' : 'failed'
        } in ${elapsed} ms.`;

        if (success) {
          this.logService.info(msg);
        } else if (req.method === 'GET' && statusCode === 404) {
          this.logService.warn(msg);
        } else {
          this.logService.error(msg);
        }
      })
    );
  }
}
